const React = require('react');
const Modal = require('react-modal');
const Validate = require('./utils/validation').validation;
const customStyles = require('./utils/modal').customStyles;
const UserService = require('./services/user').UserService;

const ProfileEdit = React.createClass({
    getInitialState: function() {
        return {
            modalIsOpen: false,
            email: (this.props && this.props.user)?this.props.user.email:'',
            errorCode: 0
        };
    },

    openModal: function() {
        this.setState({
            email: (this.props && this.props.user)?this.props.user.email:'',
            modalIsOpen: true,
            errorCode: 0});
    },

    closeModal: function() {
        this.setState({modalIsOpen: false, errorCode: 0, email: this.props.user.email});
    },

    handleEmailChange: function(e) {
        this.setState({
            email: e.target.value,
            errorCode: 0
        });
    },

    submitForm: function(event) {
        if (event)
            event.preventDefault();

        if (!Validate.validateEmail(this.state.email)) {
            this.setState({
                errorCode: 1
            });
            return;
        }

        let user = {
            ExternalID: this.props.user.externalID,
            Email: this.state.email
        };
        let _this = this;
        UserService.put(user, function (err) {
            if (!err) {
                _this.props.user.email = user.Email;
                _this.closeModal();
            } else {
                _this.setState({
                    errorCode: xmlhttp.status
                });
            }
        });
    },

    render: function() {
        return <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            style={customStyles}
            >

            <h2>EDIT PROFILE</h2>
            <form action="" onSubmit={this.submitForm} className="form-table">
                <table className="edit-header" cellSpacing="0" cellPadding="0">
                    <tbody>
                    <tr>
                        <td colSpan="2">
                            <label htmlFor="email">Email</label>
                            <input name="email" type="text" value={this.state.email} onChange={this.handleEmailChange} />
                        </td>
                    </tr>
                    <tr>
                        <td className="left center">
                            <button type="submit" className="btn waves-effect waves-light save">Save</button>
                            </td>
                        <td className="center">
                            <button type="button" value="cancel" onClick={this.closeModal} className="btn waves-effect waves-light cancel">Cancel</button>
                        </td>
                        </tr>
                    </tbody>
                </table>
                {(this.state.errorCode === 409)?<p className="error">This email address is already taken.</p>:null}
                {(this.state.errorCode === 500)?<p className="error">Your email cannot be updated at this time.</p>:null}
                {(this.state.errorCode === 1)?<p className="error">Please enter a valid email address.</p>:null}
            </form>
        </Modal>;
    }

});

exports.ProfileEdit = ProfileEdit;